import { useState } from 'react';
import Button from 'components/base/Button';
import { Col, Row, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import { addClientBulk } from 'api/api';
import { DropzoneAreaBase } from 'material-ui-dropzone';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Papa from 'papaparse';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import csvFile from '../../assets/download/dental-data.csv';

function AddClientBulk() {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [file, setFile] = useState(null);

  let breadcrumbItems = [];

  breadcrumbItems = [
    {
      label: 'Clients',
      url: '/clients/clients'
    },
    {
      label: 'Add',
      active: true
    }
  ];

  // const requiredHeaders = [
  //   'Dental Office Name',
  //   'Website',
  //   'Full_Address',
  //   'Street_Address',
  //   'City',
  //   'State',
  //   'Zip',
  //   'Country',
  //   'Dental Practice Name',
  //   'Phone_1',
  //   'email',
  //   'First_category',
  //   'Second_category',
  //   'Reviews_count',
  //   'Average_rating',
  //   'Latitude',
  //   'Longitude',
  //   'Place_ID'
  // ];

  // const validateHeaders = async () => {
  //   return new Promise((resolve, reject) => {
  //     let isValid = true;

  //     Papa.parse(file, {
  //       header: true,
  //       skipEmptyLines: true,
  //       complete: results => {
  //         const headers = results.meta.fields;
  //         const missingHeaders = requiredHeaders.filter(
  //           header => !headers.includes(header)
  //         );
  //         const extraHeaders = headers.filter(
  //           header => !requiredHeaders.includes(header)
  //         );

  //         if (missingHeaders.length === 0 && extraHeaders.length === 0) {
  //           isValid = true;
  //         } else {
  //           if (missingHeaders.length > 0) {
  //             setError([`Missing headers: ${missingHeaders.join(', ')}`]);
  //             isValid = false;
  //           }
  //           if (extraHeaders.length > 0) {
  //             setError([`Extra headers found: ${extraHeaders.join(', ')}`]);
  //             isValid = false;
  //           }
  //         }

  //         resolve(isValid);
  //       },
  //       error: err => {
  //         setError([`Error parsing file: ${err.message}`]);
  //         reject(false);
  //       }
  //     });
  //   });
  // };

  const handleSubmit = async () => {
    setError([]);

    if (!file) {
      setError(['Please select a file first.']);
      return;
    }

    // var isValid = await validateHeaders(file);

    // if (!isValid) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('csv_file', file);
      const response = await addClientBulk(formData);
      if (response.status === 200) navigate('/clients/clients');
    } catch (error) {
      setLoading(false);
      setError([error.message]);
    }

    setLoading(false);
  };

  const handleAdd = newFiles => {
    setError([]);
    setFiles(newFiles);

    const selectedFile = newFiles[0]?.file;

    if (selectedFile) {
      if (selectedFile.type !== 'text/csv') {
        setError(['Please select a valid CSV file.']);
        return;
      }

      if (selectedFile.size > 3 * 1024 * 1024) {
        // 3MB limit
        setError(['File too large. Maximum allowed size is 3MB.']);
        return;
      }

      setFile(selectedFile);
    } else {
      setError(['No file selected.']);
    }
  };

  const handleDelete = deleted => {
    setFiles(files.filter(f => f !== deleted));
    setFile(null);
  };

  const handleDownloadCsv = () => {
    const link = document.createElement('a');
    link.href = csvFile;
    link.setAttribute('download', 'client_format.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleGoBack = () => {
    navigate('/clients/clients/');
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">Add new clients</h2>
          </div>
        </div>
        <div className="ms-xxl-auto" style={{ float: 'right' }}>
          <Button variant="primary" onClick={() => handleDownloadCsv()}>
            <FontAwesomeIcon icon={faDownload} className="me-2" />
            Download CSV Format
          </Button>
        </div>
        <Row className="g-5">
          <Col xs={12} xl={8}>
            <div>
              <div>
                {Object.entries(error).length > 0 &&
                  error.map((e, index) => (
                    <Alert variant="soft-danger" key={index}>
                      {e}
                    </Alert>
                  ))}
              </div>

              {loading && <LoadingOverlay />}

              <DropzoneAreaBase
                fileObjects={files}
                onAdd={handleAdd}
                onDelete={handleDelete}
                acceptedFiles={['.csv']}
                maxFileSize={5000000}
                filesLimit={1}
                dropzoneText="Drag and drop CSV file here or click"
              />

              <div
                className="d-flex flex-wrap gap-2"
                style={{ marginTop: '10px' }}
              >
                <Button
                  variant="primary"
                  type="button"
                  onClick={e => handleSubmit(e)}
                >
                  Submit
                </Button>
                <Button
                  variant="phoenix-secondary"
                  type="button"
                  onClick={() => handleGoBack()}
                >
                  Discard
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AddClientBulk;
